<template>
  <div class="address-input">
    <div class="form-group row" :class="{ 'has-feedback' : isDirty }">
      <label :for="options.name" :class="options.fullWidth ? 'col-sm-12' : 'col-sm-4 col-form-label'">
        {{ options.label }}
        <span v-if="options.required" class="required">*</span>
      </label>
      <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-8'">
        <input class="form-control google-autocomplete" type="text"
          placeholder="Enter an address"
          :id="options.name"
          :value="value.value"
          :name="options.name"/>
        <input type="hidden"
          :id="options.name + 'Latitude'"
          :name="options.name + 'Latitude'"
          :value="value.latitude"/>
        <input type="hidden"
          :id="options.name + 'Longitude'"
          :name="options.name + 'Longitude'"
          :value="value.longitude"/>
        <span :class="validationClass" v-show="validationMessage">
          {{ validationMessage }}
        </span>
        <span :class="validationIcon" v-show="validationIcon"></span>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-xs-12 col-sm-8 offset-sm-4">
        <div style="position: relative;">
          <button class="btn btn-sm btn-primary mb-2" @click="toggle()" type="button">
            <span class="fa fa-fw" :class="{
              'fa-unlock': isLocked,
              'fa-lock': !isLocked
            }"></span>
            {{ isLocked ? 'Unlock' : 'Lock' }} Map
          </button>
          <div class="map-locked" v-show="isLocked">
            <h2 class="text-center text-muted" style="margin-top: 120px;">
              Interacting with the map is locked
            </h2>
          </div>
          <div ref="map" style="height:300px;">
          </div>
          <span class="map-info">
            Latitude: {{ value.latitude }}, Longitude: {{ value.longitude }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  validationClass,
  validationIcon,
  validationMessage
} from '@/util/helpers'
export default {
  name: 'AddressInput',
  props: {
    value: {
      type: Object,
      default () {
        return {
          value: '',
          latitude: '',
          longitude: ''
        }
      }
    },
    options: {
      type: Object,
      default () {
        return {
          name: '',
          latitude: '',
          longitude: '',
          required: false,
          noClick: false
        }
      }
    }
  },
  data () {
    return {
      isValid: false,
      isDirty: false,
      isLocked: true,
      customError: false,
      isLength: false,
      isRegex: false,
      preventLookup: false,
      marker: null,
      map: null
    }
  },
  computed: {
    validationClass,
    validationIcon,
    validationMessage,
    invalidMessage () {
      if (this.value.value) {
        return 'The address entered is not valid'
      } else {
        return this.options.label + ' is required'
      }
    }
  },
  mounted () {
    this.customError = false
    let geocoder = new google.maps.Geocoder()
    this.map = new google.maps.Map(this.$refs.map, {
      center: {lat: -25.946685, lng: 134.148848},
      zoom: 3
    })
    google.maps.event.addListener(this.map, 'idle', () => {
      google.maps.event.trigger(this.map, 'resize')
    })
    let input = document.getElementById(this.options.name)
    let searchBox = new google.maps.places.SearchBox(input)
    this.map.addListener('bounds_changed', () => {
      searchBox.setBounds(this.map.getBounds())
    })
    searchBox.addListener('places_changed', () => {
      let places = searchBox.getPlaces()
      if (places.length === 0) {
        return
      }
      this.validate({
        value: places[0].formatted_address || places[0].name,
        latitude: places[0].geometry.location.lat(),
        longitude: places[0].geometry.location.lng()
      })
      if (this.marker) this.marker.setMap(null)
      this.marker = new google.maps.Marker({
        position: places[0].geometry.location,
        draggable: true,
        animation: google.maps.Animation.DROP,
        map: this.map
      })
      this.map.panTo(places[0].geometry.location)
      this.map.setZoom(16)
      this.marker.addListener('dragend', (event) => {
        this.validate({
          ...this.value,
          latitude: event.latLng.lat(),
          longitude: event.latLng.lng()
        })
      })
    })
    if (!this.options.noClick) {
      this.map.addListener('click', (event) => {
        this.customError = false
        if (this.marker) this.marker.setMap(null)
        this.marker = new google.maps.Marker({
          position: event.latLng,
          draggable: true,
          animation: google.maps.Animation.DROP,
          map: this.map
        })
        this.validate({
          ...this.value,
          latitude: event.latLng.lat(),
          longitude: event.latLng.lng()
        })
        this.marker.addListener('dragend', (event) => {
          this.validate({
            ...this.value,
            latitude: event.latLng.lat(),
            longitude: event.latLng.lng()
          })
        })
        this.loading = true
        geocoder.geocode({'location': event.latLng}, (results, status) => {
          this.loading = false
          if (status === google.maps.GeocoderStatus.OK) {
            if (results[0]) {
              this.preventLookup = true
              this.validate({
                ...this.value,
                value: results[0].formatted_address
              })
            } else {
              this.customError = 'No results found'
            }
          } else {
            this.customError = `Geocode was not successful for the following reason: ${status}`
          }
        })
      })
    }
    if (this.value.value) {
      this.marker = new google.maps.Marker({
        position: { lat: this.value.latitude, lng: this.value.longitude },
        draggable: true,
        animation: google.maps.Animation.DROP,
        map: this.map
      })
      this.marker.addListener('dragend', (event) => {
        this.validate({
          ...this.value,
          latitude: event.latLng.lat(),
          longitude: event.latLng.lng()
        })
      })
      this.map.panTo({ lat: this.value.latitude, lng: this.value.longitude })
      this.map.setZoom(16)
    }
  },
  methods: {
    toggle () {
      this.isLocked = !this.isLocked
    },
    validate (val = this.value) {
      this.$emit('input', val)
      this.isDirty = true
      if (this.options.required && !val.value) {
        this.isValid = false
      } else {
        this.isValid = true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/AddressInput.vue